export class UpdateFechaPruebaModel{
    fecha?: Date

}